import { EPublisherSolutionModelSubType } from 'common/contracts';
import { IPermissions } from 'common/permissions.types';
import { ELocalStorageKeys } from 'constants/enums';
import { ESideBarContext } from 'design-system/AcSidebar/types';
import { permissionsUtil } from 'utils/permissionsUtil';

import { localStorageUtil } from './localStorageUtil';

export const checkDefaultPageName = (
  context: ESideBarContext,
  permissions?: IPermissions,
  id?: string
): string => {
  if (context === ESideBarContext.PORTAL) {
    return 'settings/portal';
  }

  if (permissions && id) {
    return checkDefaultProjectPage(permissions, id);
  }

  return '';
};

export const checkDefaultProjectPage = (
  permissions: IPermissions,
  publisherId?: string
) => {
  const userDetails = localStorageUtil.get(ELocalStorageKeys.USER_DETAILS);

  if (!publisherId) {
    return 'statistics';
  }

  const hasAnalyticsViewPermission = permissionsUtil.canAccessAnalytics(
    permissions,
    publisherId
  );

  const isSingleProject = userDetails?.projects?.length === 1;
  const isPaymentLinkProject =
    userDetails?.projects?.[0]?.projectSubType ===
    EPublisherSolutionModelSubType.PAYMENT_LINKS;

  if (isSingleProject && isPaymentLinkProject) {
    return 'orders';
  }

  if (hasAnalyticsViewPermission) {
    return 'statistics';
  }

  return 'bundles';
};
